'use strict'

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import './FAQLists.scss'

class FAQList extends PureComponent {
  render () {
    const { title, faqs } = this.props
    const ccn = 'top-faqs'
    const parentClassName = classnames([ccn], { [ccn + '--inverse']: this.props.inverse })

    if (!this.props.faqs) return null
    return (
      <div className={parentClassName}>
        <h2 className={ccn + '__title h1'}>{title}</h2>
        <ul className={ccn + '__lists'}>
          {
            faqs.map((faq, i) => {
              return (
                <li className={ccn + '__list'} key={i}>
                  <a className={ccn + '__link ' + ccn + '__link--' + i} href={faq.url}>{faq.question}</a>
                </li>
              )
            })
          }
        </ul>
      </div>
    )
  }
}

FAQList.propTypes = {
  title: PropTypes.string,
  faqs: PropTypes.array,
  inverse: PropTypes.bool
}

export default FAQList
